<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">{{ year }} QUARTERLY LISTING GOALS</h3>
      </b-card-header>
      <b-table-simple small responsive>
        <b-thead>
          <b-tr>
            <b-th>TIMELINE</b-th>
            <b-th colspan="2" class="text-center">
              {{ new Date(dates.start_date) | date("MMM d, Y") }} &ndash; {{ new Date(dates.end_date) | date("MMM d, Y") }} <span id="activity_tip"><i class="fas fa-question-circle"></i></span>
              <b-tooltip target="activity_tip" triggers="hover" variant="primary">
                These dates are calculated based off of your Business Information.
              </b-tooltip>
            </b-th>
            <b-th><span class="sr-only">Seasonality</span></b-th>
          </b-tr>
          <b-tr>
            <b-th>Quarters</b-th>
            <b-th>Listing Appts Held</b-th>
            <b-th>Listings Taken</b-th>
            <b-th>Seasonality</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr>
            <b-td><strong>Q1</strong></b-td>
            <b-td>{{ Math.round(totalApptsHeld * (economicModel.seasonality_q1 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalListingsTaken * (economicModel.seasonality_q1 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q1 }}%</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q2</strong></b-td>
            <b-td>{{ Math.round(totalApptsHeld * (economicModel.seasonality_q2 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalListingsTaken * (economicModel.seasonality_q2 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q2 }}%</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q3</strong></b-td>
            <b-td>{{ Math.round(totalApptsHeld * (economicModel.seasonality_q3 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalListingsTaken * (economicModel.seasonality_q3 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q3 }}%</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q4</strong></b-td>
            <b-td>{{ Math.round(totalApptsHeld * (economicModel.seasonality_q4 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalListingsTaken * (economicModel.seasonality_q4 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q4 }}%</b-td>
          </b-tr>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-td>
              <strong>Totals:</strong>
            </b-td>
            <b-td>
              <strong>{{ totalApptsHeld }}</strong>
            </b-td>
            <b-td>
              <strong>{{ totalListingsTaken }}</strong>
            </b-td>
            <b-td>
              <strong><span :class="{'text-danger':(seasonalityTotal > 100)}">{{ seasonalityTotal }}%</span></strong>
            </b-td>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">{{ year }} QUARTERLY BUYER GOALS</h3>
      </b-card-header>
      <b-table-simple small responsive>
        <b-thead>
          <b-tr>
            <b-th>TIMELINE</b-th>
            <b-th colspan="2" class="text-center">
              {{ new Date(dates.start_date) | date("MMM d, Y") }} &ndash; {{ new Date(dates.end_date) | date("MMM d, Y") }} <span id="activity_tip"><i class="fas fa-question-circle"></i></span>
              <b-tooltip target="activity_tip" triggers="hover" variant="primary">
                These dates are calculated based off of your Business Information.
              </b-tooltip>
            </b-th>
            <b-th><span class="sr-only">Seasonality</span></b-th>
          </b-tr>
          <b-tr>
            <b-th>Quarters</b-th>
            <b-th>Buyer Appts Held</b-th>
            <b-th>Buyers Taken</b-th>
            <b-th>Seasonality</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr>
            <b-td><strong>Q1</strong></b-td>
            <b-td>{{ Math.round(totalBuyersHeld * (economicModel.seasonality_q1 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalBuyersTaken * (economicModel.seasonality_q1 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q1 }}%</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q2</strong></b-td>
            <b-td>{{ Math.round(totalBuyersHeld * (economicModel.seasonality_q2 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalBuyersTaken * (economicModel.seasonality_q2 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q2 }}%</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q3</strong></b-td>
            <b-td>{{ Math.round(totalBuyersHeld * (economicModel.seasonality_q3 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalBuyersTaken * (economicModel.seasonality_q3 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q3 }}%</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q4</strong></b-td>
            <b-td>{{ Math.round(totalBuyersHeld * (economicModel.seasonality_q4 / 100)) }}</b-td>
            <b-td>{{ Math.round(totalBuyersTaken * (economicModel.seasonality_q4 / 100)) }}</b-td>
            <b-td>{{ economicModel.seasonality_q4 }}%</b-td>
          </b-tr>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-td>
              <strong>Totals:</strong>
            </b-td>
            <b-td>
              <strong>{{ totalBuyersHeld }}</strong>
            </b-td>
            <b-td>
              <strong>{{ totalBuyersTaken }}</strong>
            </b-td>
            <b-td>
              <strong><span :class="{'text-danger':(seasonalityTotal > 100)}">{{ seasonalityTotal }}%</span></strong>
            </b-td>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">{{ year }} QUARTERLY CLOSING GOALS</h3>
      </b-card-header>
      <b-table-simple small responsive>
        <b-thead>
          <b-tr>
            <b-th>TIMELINE</b-th>
            <b-th colspan="4" class="text-center" variant="danger">{{ new Date(startOfYear) | date("MMM d, yyyy") }} &ndash; {{ new Date(endOfYear) | date("MMM d, yyyy") }}</b-th>
          </b-tr>
          <b-tr>
            <b-th>Quarters</b-th>
            <b-th>Closings</b-th>
            <b-th>Volume</b-th>
            <b-th>GCI</b-th>
            <b-th>Profit</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr>
            <b-td><strong>Q1</strong></b-td>
            <b-td>{{ Math.round(closedUnits * (economicModel.seasonality_q1 / 100)) }}</b-td>
            <b-td>{{ Math.round(closedSalesVolume * (economicModel.seasonality_q1 / 100)) | currency }}</b-td>
            <b-td>
              <span v-if="cos.team_member == 1">{{ Math.round(grossProfit * (economicModel.seasonality_q1 / 100)) | currency }}</span>
              <span v-else>{{ Math.round(companyGci * (economicModel.seasonality_q1 / 100)) | currency }}</span>
            </b-td>
            <b-td>{{ economicModel.net_profit_goal * (economicModel.seasonality_q1 / 100) | currency }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q2</strong></b-td>
            <b-td>{{ Math.round(closedUnits * (economicModel.seasonality_q2 / 100)) }}</b-td>
            <b-td>{{ Math.round(closedSalesVolume * (economicModel.seasonality_q3 / 100)) | currency }}</b-td>
            <b-td>
              <span v-if="cos.team_member == 1">{{ Math.round(grossProfit * (economicModel.seasonality_q2 / 100)) | currency }}</span>
              <span v-else>{{ Math.round(companyGci * (economicModel.seasonality_q2 / 100)) | currency }}</span>
            </b-td>
            <b-td>{{ economicModel.net_profit_goal * (economicModel.seasonality_q2 / 100) | currency }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q3</strong></b-td>
            <b-td>{{ Math.round(closedUnits * (economicModel.seasonality_q3 / 100)) }}</b-td>
            <b-td>{{ Math.round(closedSalesVolume * (economicModel.seasonality_q3 / 100)) | currency }}</b-td>
            <b-td>
              <span v-if="cos.team_member == 1">{{ Math.round(grossProfit * (economicModel.seasonality_q3 / 100)) | currency }}</span>
              <span v-else>{{ Math.round(companyGci * (economicModel.seasonality_q3 / 100)) | currency }}</span>
            </b-td>
            <b-td>{{ economicModel.net_profit_goal * (economicModel.seasonality_q3 / 100) | currency }}</b-td>
          </b-tr>
          <b-tr>
            <b-td><strong>Q4</strong></b-td>
            <b-td>{{ Math.round(closedUnits * (economicModel.seasonality_q4 / 100)) }}</b-td>
            <b-td>{{ Math.round(closedSalesVolume * (economicModel.seasonality_q4 / 100)) | currency }}</b-td>
            <b-td>
              <span v-if="cos.team_member == 1">{{ Math.round(grossProfit * (economicModel.seasonality_q4 / 100)) | currency }}</span>
              <span v-else>{{ Math.round(companyGci * (economicModel.seasonality_q4 / 100)) | currency }}</span>
            </b-td>
            <b-td>{{ economicModel.net_profit_goal * (economicModel.seasonality_q4 / 100) | currency }}</b-td>
          </b-tr>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-td>
              <strong>Totals:</strong>
            </b-td>
            <b-td>
              <strong>{{ closedUnits }}</strong>
            </b-td>
            <b-td>
              <strong>{{ closedSalesVolume | currency }}</strong>
            </b-td>
            <b-td>
              <strong>
                <span v-if="cos.team_member == 1">{{ grossProfit | currency }}</span>
                <span v-else>{{ companyGci | currency }}</span>
              </strong>
            </b-td>
            <b-td>
              <strong>{{ economicModel.net_profit_goal | currency }}</strong>
            </b-td>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import { mapGetters } from 'vuex';

export default {
  mixins: [errorsMixin],
  props: {
    year: null
  },
  data() {
    return {
      dates: {
        start_date: null,
        end_date: null
      },
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      economicModel: 'economicModel/economicModel',
      cos: 'cos/cos',
      closedUnits: 'economicModel/closedUnits',
      closedSalesVolume: 'economicModel/closedSalesVolume',
      companyGci: 'economicModel/companyGci',
      grossProfit: 'economicModel/grossProfit',
      totalApptsHeld: 'economicModel/totalApptsHeld',
      totalListingsTaken: 'economicModel/totalListingsTaken',
      totalBuyersHeld: 'economicModel/totalBuyersHeld',
      totalBuyersTaken: 'economicModel/totalBuyersTaken'
    }),
    startOfYear() {
      return new Date(this.year, 0, 1);
    },
    endOfYear() {
      return new Date(this.year, 11, 31);
    },
    seasonalityTotal() {
      const economicModel = this.economicModel;
      return Number(economicModel.seasonality_q1) + Number(economicModel.seasonality_q2) + Number(economicModel.seasonality_q3) + Number(economicModel.seasonality_q4);
    }
  },
  methods: {
    getDates() {
      axios.get(this.userRoute + "/team/dates?year=" + this.year)
      .then(response => {
        this.dates = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
  },
  created() {
    this.getDates();
  },
  watch: {
    year(to, from) {
      this.getDates();
    }
  }
};
</script>